import { ButtonLink, Heading, PageContainer, StaggerGroup, StaggerItem, Text } from "@/components/ui";
import { STAGGER } from "@/lib/motion";
import LottieComponent from "../lottie-animations/LottieComponent"

export default function EmptyCart() {
  return (
    <PageContainer as="main" className="flex min-h-fill flex-col items-center pb-12 text-center">
      <StaggerGroup step="loose" delay={STAGGER.tight} className="flex w-full flex-col items-center gap-4">
        <StaggerItem>
          <LottieComponent />
        </StaggerItem>

        <StaggerItem className="max-w-sm space-y-2">
          <Heading level={1}>Sua sacola está vazia</Heading>
          <Text size="base" tone="muted">
            Dê uma olhada no cardápio e comece a montar seu pedido.
          </Text>
        </StaggerItem>

        <StaggerItem className="mt-4 w-full max-w-sm">
          <ButtonLink to="/" size="lg" fullWidth>
            Ver cardápio
          </ButtonLink>
        </StaggerItem>
      </StaggerGroup>
    </PageContainer>
  )
}
